module.exports = __webpack_public_path__ + "static/media/3.1854a0bc.jpg";